export default {
    instructionCenter: {
        title: 'AI Instructions',
        searchPlaceholder: 'Search instructions...',
        gridView: 'Grid View',
        listView: 'List View',
        createInstruction: 'Create Instruction',
        noInstructions: 'No instructions',
        noInstructionsDesc: 'Click "Create Instruction" to add your first instruction',
        loading: 'Loading',
        loadMore: 'Load More',
        preview: 'Preview',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving',
        moreActions: 'More Actions',
        editInstruction: 'Edit Instruction',
        addFavorite: 'Add to Favorites',
        removeFavorite: 'Remove from Favorites',
        noResults: 'No instructions found',

        // Select Dialog
        selectDialog: {
            title: 'Select from Library',
            forSection: 'For Section',
        },

        // Technology Area
        technologyArea: {
            general: 'General',
            electrical: 'Electrical',
            mechanical: 'Mechanical',
            chemical: 'Chemical',
            software: 'Software',
        },

        // Section
        section: {
            title: 'Title',
            background: 'Background',
            summary: 'Summary',
            briefFigures: 'Brief Figures',
            claims: 'Claims',
            abstract: 'Abstract',
            detailed: 'Detailed',
            detailedPlan: 'Detailed Plan',
            repeatClaims: 'Repeat Claims',
            custom: 'Custom',
            USC_101: '35 U.S.C. § 101',
            USC_102: '35 U.S.C. § 102',
            USC_103: '35 U.S.C. § 103',
            USC_112A_ENABLEMENT: '35 U.S.C. § 112(a) Enablement',
            USC_112A_WRITTEN_DESCRIPTION: '35 U.S.C. § 112(a) Written Description',
            USC_112B: '35 U.S.C. § 112(b)',
            CLAIM_OBJECTION: 'Claim Objection',
            DRAWING_OBJECTION: 'Drawing Objection',
            SPECIFICATION_OBJECTION: 'Specification Objection',
            DOUBLE_PATENTING: 'Double Patenting',
            PRIORITY_CLAIM: 'Priority Claim',
            RESTRICTION_REQUIREMENT: 'Restriction Requirement',
            INFORMATION_DISCLOSURE: 'Information Disclosure Statement',
        },

        // Filter
        filter: {
            title: 'Filters',
            region: 'Region',
            type: 'Type',
            from: 'From',
            myInstructions: 'My Instructions',
            library: 'Library',
            clear: 'Clear {count} filter{plural}',
        },

        // Tabs
        tabs: {
            all: 'All',
            title: 'Title',
            abstract: 'Abstract',
            background: 'Background',
            summary: 'Summary',
            claims: 'Claims',
            detailedDescription: 'Detailed Description',
            officeActionResponse: 'Office Action Response',
            myInstructions: 'My Instructions',
            favorites: 'Favorites',
        },

        // Pills
        pills: {
            all: 'All Instructions',
            my: 'My Instructions',
            official: 'Official Instructions',
        },

        // Sections
        sections: {
            title: 'Title',
            abstract: 'Abstract',
            background: 'Background',
            technicalField: 'Technical Field',
            summary: 'Summary of Invention',
            briefFigures: 'Brief Description of Figures',
            claims: 'Claims',
            detailed: 'Detailed Description',
            custom: 'Custom',
        },

        // Instruction Types
        instructionTypes: {
            patentApplication: 'Patent Application',
            inventionDisclosure: 'Invention Disclosure',
            officeActionResponse: 'Office Action Response',
        },

        // Sources
        sources: {
            system: 'System',
            custom: 'Custom',
            library: 'Library',
        },

        // Dialog
        dialog: {
            name: 'Instruction Name',
            namePlaceholder: 'Enter instruction name',
            instructionType: 'Instruction Type',
            templateSection: 'Template Section',
            selectSection: 'Select template section',
            description: 'Description',
            descriptionPlaceholder: 'Enter description (optional)',
            descriptionHint: 'Briefly describe the purpose and features of this instruction',
            content: 'AI Instruction Content',
            contentPlaceholder: 'Enter AI instruction content that will guide AI on how to generate content...',
            contentHint: 'Describe in detail how AI should process and generate content, including style, format, focus, etc.',
            advancedSettings: 'Advanced Settings',
            region: 'Region',
            technologyArea: 'Technology Area',
            optional: 'Optional',
            quickSettings: 'Quick Settings',
            requiredFieldsHint: '* indicates required field',
            fillBasicInfo: 'Fill in basic information to create a new instruction',
            updateHint: 'Update instruction information',
            viewOnlyHint: 'View system instruction details (read-only mode)',
            unsavedChangesTitle: 'Unsaved Changes',
            unsavedChangesMessage: 'You have unsaved changes. Are you sure you want to close? Your changes will be lost.',
            discardChanges: 'Discard Changes',
            continueEditing: 'Continue Editing',
            systemReadOnlyHint: 'System instructions are read-only and cannot be edited',
            close: 'Close',

            // Level selection (Super Admin only)
            level: 'Visibility',
            adminOnly: 'Admin Only',
            systemLevel: 'System Level',
            userLevel: 'User Level',
        },

        // Messages
        messages: {
            saveFailed: 'Failed to save',
            fetchListFailed: 'Failed to fetch instructions',
            fetchDetailFailed: 'Failed to fetch instruction detail',
            createSuccess: 'Created successfully',
            createFailed: 'Failed to create',
            updateSuccess: 'Updated successfully',
            updateFailed: 'Failed to update',
            deleteSuccess: 'Deleted successfully',
            deleteFailed: 'Failed to delete',
            addFavoriteSuccess: 'Added to favorites',
            removeFavoriteSuccess: 'Removed from favorites',
            favoriteOperationFailed: 'Favorite operation failed',
        },
    },
};
